export default "__VITE_ASSET__kCXyLvUI__"